// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Certificado_hidden__3CDwG","form":"Certificado_form__Y9NRF","content":"Certificado_content__3wmJR","link":"Certificado_link__OUvho"};